import './src/style/global-style.scss';
import './static/ck-edytor-content.css';

import { trackPageView, setFbConsent } from './src/utills/FbAnalytics';
import { setDeferredPrompt } from './src/utills/pwa-install-prompt';
export { default as wrapRootElement } from './src/redux/store';

const restoreFbConsent = () => {
    try {
        if (localStorage.getItem('cookies')) {
            setFbConsent('grant');
        }
    } catch (e) {}
};

export const onClientEntry = () => {
    restoreFbConsent();

    window.addEventListener('beforeinstallprompt', (event) => {
        event.preventDefault();
        setDeferredPrompt(event);
        window.dispatchEvent(new Event('pwa-installable'));
    });
};

export const shouldUpdateScroll = ({ pathname, prevRouterProps, routerProps }) => {
    const prevPathname = prevRouterProps?.location.pathname;
    const preventScroll = routerProps.location.state?.preventScroll;
    const { location } = routerProps;
    if (location.hash) {
        const elementId = location.hash.substring(1);
        document.getElementById(`${elementId}`)?.scrollIntoView();
        return false;
    }
    return !(prevPathname === pathname || preventScroll);
};

export const onRouteUpdate = ({ location }) => {
    trackPageView(location.pathname);
};
